import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { _SharePointQueryableInstance } from "../sharepointqueryable.js";
import { hOP, DefaultRuntime } from "@pnp/common";
import { defaultPath } from "../decorators.js";
import { tag } from "../telemetry.js";
var _Suggest = /** @class */ (function (_super) {
    __extends(_Suggest, _super);
    function _Suggest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _Suggest.prototype.execute = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var response, mapper;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.mapQueryToQueryString(query);
                        return [4 /*yield*/, this.get()];
                    case 1:
                        response = _a.sent();
                        mapper = hOP(response, "suggest") ? function (s_1) { return response.suggest[s_1].results; } : function (s_2) { return response[s_2]; };
                        return [2 /*return*/, {
                                PeopleNames: mapper("PeopleNames"),
                                PersonalResults: mapper("PersonalResults"),
                                Queries: mapper("Queries"),
                            }];
                }
            });
        });
    };
    _Suggest.prototype.mapQueryToQueryString = function (query) {
        var _this = this;
        var setProp = function (q) { return function (checkProp) { return function (sp) {
            if (hOP(q, checkProp)) {
                _this.query.set(sp, q[checkProp].toString());
            }
        }; }; };
        this.query.set("querytext", "'" + query.querytext + "'");
        var querySetter = setProp(query);
        querySetter("count")("inumberofquerysuggestions");
        querySetter("personalCount")("inumberofresultsuggestions");
        querySetter("preQuery")("fprequerysuggestions");
        querySetter("hitHighlighting")("fhithighlighting");
        querySetter("capitalize")("fcapitalizefirstletters");
        querySetter("culture")("culture");
        querySetter("stemming")("enablestemming");
        querySetter("includePeople")("showpeoplenamesuggestions");
        querySetter("queryRules")("enablequeryrules");
        querySetter("prefixMatch")("fprefixmatchallterms");
    };
    __decorate([
        tag("su.execute")
    ], _Suggest.prototype, "execute", null);
    _Suggest = __decorate([
        defaultPath("_api/search/suggest")
    ], _Suggest);
    return _Suggest;
}(_SharePointQueryableInstance));
export { _Suggest };
export var Suggest = function (baseUrl, options, runtime) {
    if (options === void 0) { options = {}; }
    if (runtime === void 0) { runtime = DefaultRuntime; }
    return function (query) {
        return (new _Suggest(baseUrl)).configure(options).setRuntime(runtime).execute(query);
    };
};
//# sourceMappingURL=suggest.js.map